import { reduce } from 'lodash';
import Joi from 'joi-browser';

// this is a method that takes in a fieldDefinitions blob after its
// component classes have been loaded and produces a Joi-compatible
// validation schema.
const schemaObjectify = fieldDefinitions =>
  Joi.object().keys(reduce(
    fieldDefinitions,
    (result, fieldDefinition, key) => {
      const newResult = Object.assign({}, result);
      const {
        validationSchema,
        required,
        label,
        dependency,
        requiredWithDependency,
      } = fieldDefinition;

      if (!validationSchema) return newResult;

      // Set the validation schema for the field, and add the label.
      newResult[key] = validationSchema.label(label);
      // Chain required to field if necessary.
      if (required) {
        newResult[key] = newResult[key].required();
      }
      // If dependant on
      if (dependency && requiredWithDependency) {
        newResult[key] = newResult[key].when(dependency, { is: true, then: Joi.required() });
      }
      return newResult;
    },
    {},
  ));

export default schemaObjectify;



// WEBPACK FOOTER //
// ./src/utilities/schemaObjectify.js